export const GET_CREATOR_DETAILS = "eud/auth/creator/details";

// start - CREATOR_CONTACT_MODES
export const CREATOR_CONTACT_MODE_TELEGRAM = "Telegram" as const;
export const CREATOR_CONTACT_MODE_WHATSAPP = "Whatsapp" as const;
// end - CREATOR_CONTACT_MODES
